import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigurationService } from "../configuration.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { ExportService } from "app/reports/services/export.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { serialMap } from "chartist";

@Component({
  selector: "app-search-billing-config-master",
  templateUrl: "./search-billing-config-master.component.html",
  styleUrls: ["./search-billing-config-master.component.scss"],
})
export class SearchBillingConfigMasterComponent implements OnInit {
  destroysearchbilling$: Subject<boolean> = new Subject<boolean>();
  private getConfigurationarray: any = [];
  searchText: string = '';
  private filteredArray: any[] = [];
  butenabledisablebtn: any
  constructor(public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private dashboardService: DashboardService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<SearchBillingConfigMasterComponent>,
    private exportdata: ExportService
  ) { }
  ngOnInit(): void {
    if (this.data) {
      this.butenabledisablebtn = this.data.enableButton;
    }
    this.getBillingConfigurationSearch()
  }



  getBillingConfigurationSearch() {
    this.configurationService.GetBillingConfigurationSetupByBillConfigurationId(0).pipe(takeUntil(this.destroysearchbilling$)).subscribe((res) => {
      this.getConfigurationarray = res;
      this.filteredArray = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  // filterTable() {
  //   this.filteredArray = this.getConfigurationarray.filter((item) =>
  //     Object.keys(item)
  //       .map((key) => item[key])
  //       .join(' ')
  //       .toLowerCase()
  //       .includes(this.searchText.toLowerCase())
  //   );
  // }

filterTable() {
  const search = this.searchText?.toLowerCase() || '';
  this.filteredArray = this.getConfigurationarray.filter((item) =>
    (item.branchName && item.branchName.toLowerCase().includes(search)) ||
    (item.branchCode && item.branchCode.toLowerCase().includes(search)) ||
    (item.partyName && item.partyName.toLowerCase().includes(search)) ||
    (item.categoryName && item.categoryName.toLowerCase().includes(search)) ||
    (item.billTypeName && item.billTypeName.toLowerCase().includes(search)) ||
    (item.doctorName && item.doctorName.toLowerCase().includes(search)) ||
    (item.billSerieseName && item.billSerieseName.toLowerCase().includes(search)) ||
    (item.referredPerson && item.referredPerson.toLowerCase().includes(search)) ||
    (item.freshService && item.freshService.toString().toLowerCase().includes(search)) ||
    (item.reviewService && item.reviewService.toString().toLowerCase().includes(search)) ||
    (item.limitDays != null && item.limitDays.toString().toLowerCase().includes(search)) ||
    (item.consultationConfigType && item.consultationConfigType.toString().toLowerCase().includes(search)) ||
    (item.followup && item.followup.toLowerCase().includes(search)) ||
    (item.rateListName && item.rateListName.toLowerCase().includes(search))
  );
}




  selectRow(selectedData: any) {
    this.configurationService.selectedbillConfigData = selectedData
    if (selectedData.consultationConfigType) {
      this.configurationService.selectedbillConfigData.consultationConfigType = selectedData.consultationConfigType;
    }
    this.dialogRef.close(selectedData);
  }
  closedialog() {
    this.dialog.closeAll();
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'Patient Billing-Config Master List');

  }
  ngOnDestroy() {
    this.destroysearchbilling$.next(true);
    this.destroysearchbilling$.unsubscribe();
    this.filteredArray = null;
    this.getConfigurationarray = null
  }
}
